import { useCallback } from 'react';
import { InfiniteComboBox } from './InfiniteComboBox';
import { modelsApi } from '@/features/models/api';

interface ModelSelectProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  error?: string;
  allowEmpty?: boolean;
  label?: string;
}

export function ModelSelect({
  value,
  onChange,
  disabled,
  error,
  allowEmpty = true,
  label = 'Model',
}: ModelSelectProps) {
  const fetchOptions = useCallback(
    async ({ page, search }: { page: number; search: string }) => {
      const result = await modelsApi.list({
        lightweight: true,
        page,
        limit: 50,
        search: search || undefined,
        sortBy: 'name',
        sortOrder: 'asc',
      });

      return {
        items: result.items.map((m) => ({ id: m.id, label: m.name })),
        hasMore: result.pagination.page < result.pagination.totalPages,
      };
    },
    []
  );

  return (
    <InfiniteComboBox
      value={value}
      onChange={onChange}
      fetchOptions={fetchOptions}
      label={label}
      placeholder="Search models..."
      error={error}
      disabled={disabled}
      allowEmpty={allowEmpty}
      emptyLabel="No model selected"
    />
  );
}
